<script>
import diacritic from 'diacritic';
import { bus } from '../../main';

export default {
  name: 'VirtualScrollListItem',
  filters: {
    mark: (str, query) => {
      if (query.length) {
        const originalValue = str.toString();
        const originalValueNoDiacritics = diacritic.clean(originalValue.toLowerCase());
        const queryNoDiacritics = diacritic.clean(query.toLowerCase());

        const indexOfFirstHit = originalValueNoDiacritics.indexOf(queryNoDiacritics);
        if (indexOfFirstHit >= 0) {
          const originalTerm = originalValue.substring(indexOfFirstHit, indexOfFirstHit + query.length);
          const regex = new RegExp(originalTerm, 'ig');
          return originalValue.replace(regex, (res) => `<mark>${res}</mark>`);
        }
      }
      return str.toString();
    },
  },
  props: {
    index: { // index of current item
      type: Number,
      default: null,
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      },
    },
    searchTerm: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: '',
      bus,
    };
  },
  methods: {
    setActive(e, item) {
      this.target = e.currentTarget;
      this.active = item;
    },
  },
};
</script>
<template>
  <div>
    <strong
      :id="source.id"
      class="alphabetical-list__results__separator"
      tabindex="-1"
      v-if="source.isLetter"
    >
      <span class="alphabetical-list__results__separator__bg">{{ source.title }}</span>
    </strong>

    <a
      :href="source.links.length ? source.links[0].url : '#'"
      class="alphabetical-list__results__item"
      @click.prevent="bus.$emit('handle-virtual-scroll-list-item-click', {source: source, event: $event})"
      v-if="!source.isLetter"
    >
      <span
        class="alphabetical-list__results__title"
        v-html="$options.filters.mark(source.title, searchTerm)"
      />
      <span
        class="alphabetical-list__results__desc"
        v-html="$options.filters.mark(source.desc, searchTerm)"
      />
    </a>
  </div>
</template>
